<template>
    <div class="bottom-menu-bar">
        <!-- Todo：替换icon -->
        <router-link v-if="VIEW_CONFIG.bottomMenuBar.showCollate" to="/collate" class="bottom-menu-item" replace>
            <p><i class="bm-icon iconfont icon-qipan2"></i></p>
            <p class="bm-text">天时子平</p>
        </router-link>
        <router-link v-if="VIEW_CONFIG.bottomMenuBar.showRecord" to="/record" class="bottom-menu-item" replace>
            <p><i class="bm-icon iconfont" v-bind:class="{'icon-record': curPath.indexOf('record') == -1, 'icon-record-shi': curPath.indexOf('record') != -1}"></i></p>
            <p class="bm-text">八字库</p>
        </router-link>
        <router-link v-if="VIEW_CONFIG.bottomMenuBar.showDiscuss" to="/discussmain" class="bottom-menu-item" replace>
            <p><i class="bm-icon iconfont" v-bind:class="{'icon-discuss': curPath.indexOf('discussmain') == -1, 'icon-discuss-shi': curPath.indexOf('discussmain') != -1}"></i></p>
            <p class="bm-text">论盘精进</p>
        </router-link>
        <!-- <router-link v-if="VIEW_CONFIG.bottomMenuBar.showFamousPedia" to="/famouspedia" class="bottom-menu-item" replace>
            <p><i class="bm-icon iconfont" v-bind:class="{'icon-pedia': curPath.indexOf('famouspedia') == -1, 'icon-pedia-shi': curPath.indexOf('famouspedia') != -1}"></i></p>
            <p class="bm-text">名人百科</p>
        </router-link> -->
        <router-link v-if="VIEW_CONFIG.bottomMenuBar.showHuangLi"  to="/calendar" class="bottom-menu-item" replace>
            <p><i class="bm-icon iconfont icon-calendar"></i><span class="bm-num">{{day}}</span></p>
            <p class="bm-text">{{text+'日'}}</p>
        </router-link>
        <router-link v-if="VIEW_CONFIG.bottomMenuBar.showMy" to="/my" class="bottom-menu-item" replace>
            <p><i class="bm-icon iconfont" v-bind:class="{'icon-wode': curPath.indexOf('my') == -1, 'icon-wode2': curPath.indexOf('my') != -1}"></i></p>
            <p class="bm-text">我的</p>
            <span v-if="showVipReminder" class="red-circle"></span>
        </router-link>
    </div>
</template>

<script>
import { FORMAT } from '../modules/data/core/format';
import { PAIPAN } from '../modules/data/core/paipan';
import { MOMENT_TIME } from '../modules/momenttime';
import { VIEW_CONFIG } from '../modules/viewconfig';
export default {
    name: 'BottomMenuBar',
    computed: {
        curPath() {
            return this.$store.state.public.curPath;
        },
        showVipReminder() {
            return this.$store.state.reminder.showVipReminder;
        }
    },
    data() {
        return {
            VIEW_CONFIG: VIEW_CONFIG,
            day: 0,
            text: '黄历'
        }
    },
    mounted() {
        this.initTime();
    },
    methods:{
        initTime() {
            // 今天几号
            var now = MOMENT_TIME.getTimeArrayByTimeStamp();
            this.day = now[2];
            // 日干支
            var baziInfo = PAIPAN.GetInfo(0, now, 0);
            this.text = FORMAT.getTianGanByIndex(baziInfo.tg[2]) + FORMAT.getDiZhiByIndex(baziInfo.dz[2]);
        },
    }
}
</script>